"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6426],{

/***/ 472327:
/***/ (function(module) {



function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-var-requires */
/** Delimiter to be used for separating child properties */
var CHILD_DELIMITER = "-";

/** Child properties starting with this, will be available directly like color-primary, instead of color-primary-main */
var DEFAULT_CHILDREN = "__";
var DESCRIPTION_PROPERTY = "__description";

/**
 * @typedef {{key: keyName, value: obj}} CssVariable
 */

var isPrimitive = function isPrimitive(value) {
  return ["string", "number", "boolean"].includes(_typeof(value));
};
var parseThemeObject = function parseThemeObject(theme) {
  /**
   * @type {CssVariable[]}
   */
  var cssVariables = [];
  var parseRecursively = function parseRecursively(obj) {
    var keyPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (isPrimitive(obj)) {
      // primitive
      var keyName = keyPath.join(CHILD_DELIMITER);
      var thisKey = keyPath.pop();
      if (thisKey === DEFAULT_CHILDREN) {
        keyName = keyPath.join(CHILD_DELIMITER);
      }
      cssVariables.push({
        key: keyName,
        value: obj
      });
      return;
    }
    Object.entries(obj).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (Array.isArray(value)) {
        value.forEach(function (singleVal, index) {
          return parseRecursively(singleVal, [].concat(_toConsumableArray(keyPath), [key, index]));
        });
      }
      parseRecursively(value, [].concat(_toConsumableArray(keyPath), [key]));
    });
  };
  parseRecursively(theme);
  return cssVariables;
};

/**
 * Get Line to be injected in CSS/Scss
 * @param {String} key
 * @param {String} value
 * @param {'css' | 'scss'} type
 */
var getVariableLine = function getVariableLine(key, value) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "css";
  if (key.includes(DESCRIPTION_PROPERTY)) {
    return "/* ".concat(value, " */");
  }
  if (type === "css") {
    key = "--".concat(key);
  }
  if (type === "scss") {
    key = "$".concat(key);
    value = JSON.stringify(value || "");
  }
  return "".concat(key, ": ").concat(value || '""', ";");
};

/**
 *
 * @param {CssVariable[]} cssVariables
 * @returns css-variables surrounded by :root
 */
var getCssContent = function getCssContent(cssVariables) {
  var cssVariablesStr = cssVariables.map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value;
    return getVariableLine(key, value, "css");
  }).join("\n  ");
  cssVariablesStr = ":root{\n  ".concat(cssVariablesStr, "\n}");
  return cssVariablesStr;
};
var getScssContent = function getScssContent(cssVariables) {
  var scssVariablesStr = cssVariables.map(function (_ref4) {
    var key = _ref4.key,
      value = _ref4.value;
    return getVariableLine(key, value, "scss");
  }).join("\n");
  return scssVariablesStr;
};
var getCssFromThemeObject = function getCssFromThemeObject(theme) {
  var cssVariables = parseThemeObject(theme);
  return getCssContent(cssVariables);
};
module.exports = {
  getCssContent: getCssContent,
  getScssContent: getScssContent,
  getCssFromThemeObject: getCssFromThemeObject,
  parseThemeObject: parseThemeObject
};

/***/ }),

/***/ 952301:
/***/ (function(module) {



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-undef */

var colors = {
  accent: {
    100: "#D8E5FE",
    200: "#B1C9FE",
    300: "#8AABFE",
    400: "#6D92FD",
    500: "#3D6AFD",
    600: "#2C50D9",
    700: "#1E3AB6",
    800: "#132892",
    900: "#0B1A79"
  },
  success: {
    100: "#F1FBD1",
    200: "#E1F8A4",
    300: "#C5EC73",
    400: "#A7D94E",
    500: "#7FC11D",
    600: "#65A515",
    700: "#4E8A0E",
    800: "#3A6F09",
    900: "#2B5C05"
  },
  warning: {
    100: "#FFFAD6",
    200: "#FFF4AD",
    300: "#FFEC83",
    400: "#FFE565",
    500: "#FFD932",
    600: "#DBB524",
    700: "#B79419",
    800: "#93730F",
    900: "#7A5C09"
  },
  danger: {
    100: "#FFE7D5",
    200: "#FFCAAB",
    300: "#FFA581",
    400: "#FF8261",
    500: "#FF492D",
    600: "#DB2B20",
    700: "#B7161A",
    800: "#930E1C",
    900: "#7A081D"
  }
};
var spacing = {
  __description: "Spacing",
  0: "0",
  2: "0.125rem",
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem"
};
var shadows = {
  0: "none",
  1: "0 0.0625rem 0.1875rem rgba(0,0,0,0.12), 0 0.0625rem 0.125rem rgba(0,0,0,0.24)",
  2: "0 0.125rem 0.25rem rgba(0,0,0,0.14), 0 0.125rem 0.1875rem rgba(0,0,0,0.22)",
  3: "0 0.1875rem 0.3125rem rgba(0,0,0,0.16), 0 0.1875rem 0.25rem rgba(0,0,0,0.20)",
  4: "0 0.25rem 0.375rem rgba(0,0,0,0.18), 0 0.25rem 0.3125rem rgba(0,0,0,0.18)",
  5: "0 0.3125rem 0.4375rem rgba(0,0,0,0.20), 0 0.3125rem 0.375rem rgba(0,0,0,0.16)",
  6: "0 0.375rem 0.5rem rgba(0,0,0,0.22), 0 0.375rem 0.4375rem rgba(0,0,0,0.14)",
  7: "0 0.4375rem 0.5625rem rgba(0,0,0,0.24), 0 0.4375rem 0.5rem rgba(0,0,0,0.12)",
  8: "0 0.5rem 0.625rem rgba(0,0,0,0.26), 0 0.5rem 0.5625rem rgba(0,0,0,0.10)"
};
var theme = {
  theme: "dark",
  screens: {
    lg: "768px"
  },
  spacing: spacing,
  color: {
    __description: "Color palette",
    primary: {
      __: "#111111",
      main: "#111111",
      hover: "#181818",
      active: "#080808",
      disabled: "#525252",
      bgLight: "#EEEEEE"
    },
    accent: {
      __: colors.accent[800],
      main: colors.accent[800],
      hover: colors.accent[700],
      active: colors.accent[900],
      disabled: colors.accent[500],
      bgLight: colors.accent[200]
    },
    success: {
      __: colors.success[800],
      main: colors.success[800],
      hover: colors.success[700],
      active: colors.success[900],
      disabled: colors.success[500],
      bgLight: colors.success[200]
    },
    warning: {
      __: colors.warning[700],
      main: colors.warning[700],
      hover: colors.warning[600],
      active: colors.warning[800],
      disabled: colors.warning[400],
      bgLight: colors.warning[200]
    },
    danger: {
      __: colors.danger[700],
      main: colors.danger[700],
      hover: colors.danger[600],
      active: colors.danger[800],
      disabled: colors.danger[400],
      bgLight: colors.danger[200]
    }
  },
  borderRadius: {
    __description: "Shapes",
    none: "0",
    sm: "0.125rem",
    md: "0.375rem",
    lg: "0.5rem",
    full: "100rem"
  },
  typography: {
    __description: "Typography & Fonts",
    fontFamily: "",
    fontFamilyCode: "",
    fontFamilyTagline: "",
    fontFamilySystem: "",
    fontWeightSemiBold: 600,
    fontWeightExtraBold: 800,
    h1: {
      fontFamily: "",
      fontSize: "clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)",
      fontWeight: 800,
      lineHeight: 1.1142857142857143
    },
    h2: {
      fontFamily: "",
      fontSize: "clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)",
      fontWeight: 800,
      lineHeight: 1.2222222222222223,
      color: "#132F4C"
    },
    h3: {
      fontFamily: "",
      fontSize: "2.25rem",
      lineHeight: 1.2222222222222223,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h4: {
      fontFamily: "",
      fontSize: "1.75rem",
      lineHeight: 1.5,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h5: {
      fontFamily: "",
      fontSize: "1.5rem",
      lineHeight: 1.5,
      letterSpacing: 0.1,
      color: "#007FFF",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h6: {
      fontSize: "1.25rem",
      lineHeight: 1.5,
      fontFamily: "",
      fontWeight: 500,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    button: {
      textTransform: "initial",
      fontWeight: 700,
      letterSpacing: 0,
      fontFamily: "",
      fontSize: "0.875rem",
      lineHeight: 1.75,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    subtitle1: {
      fontSize: "1.125rem",
      lineHeight: 1.3333333333333333,
      letterSpacing: 0,
      fontWeight: 500,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    caption: {
      display: "inline-block",
      fontSize: "0.75rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontWeight: 700,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    allVariants: {
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    subtitle2: {
      fontFamily: "",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    overline: {
      fontFamily: "",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      textTransform: "uppercase",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    }
  },
  shadows: _objectSpread(_objectSpread({}, shadows), {}, {
    appBar: shadows["3"],
    fab: shadows["5"]
  }),
  transition: {
    __description: "Animations timings",
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    duration: {
      s: 100,
      m: 250,
      l: 500
    }
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  }
};
module.exports = {
  theme: theme,
  colors: colors
};

/***/ }),

/***/ 376267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698616);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(353978);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(268037);





var Categories = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var storeInfo = (0,src_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "categories-page",
        children: [
            (ref = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_1__/* .specificThemeRender */ .t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "categories-main",
                children: (ref3 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_1__/* .specificThemeRender */ .t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.CLP) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        showSeeMoreBtn: false
                    }, layout));
                })
            }),
            (ref6 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_1__/* .specificThemeRender */ .t)(storeInfo)) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.components) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Footer) === null || ref8 === void 0 ? void 0 : ref8.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Categories);


/***/ }),

/***/ 755847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

}]);